import React, { memo, createElement as _createElement } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withFormsy } from 'formsy-react';
import { Checkbox as ReaxlCheckbox, FormElementHelp, ErrorMessages } from 'reaxl';
import { createChainedFunction } from '@atc/create-chained-function';
import CommonFormComponent from '../hocs/CommonFormComponent';
import cleanFormProps from '../cleanFormProps';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Checkbox(_ref) {
  let {
    disabled = false,
    formElementProps = {},
    id,
    isFormDisabled,
    label,
    labelClassName,
    onChange,
    optional = false,
    rootClasses,
    secondaryLabel,
    setValue,
    value = false,
    ...rest
  } = _ref;
  const handleChange = event => {
    setValue(event.currentTarget.checked);
  };
  const componentProps = ['attachToForm', 'detachFromForm', 'displayName', 'errorMessage', 'forwardedRef', 'hasValue', 'isFormSubmitted', 'isPristine', 'innerRef', 'isRequired', 'isValid', 'isValidValue', 'options', 'resetValue', 'runValidation', 'rowLabel', 'rootClasses', 'setValidations', 'showError', 'showRequired', 'validate', 'validations'];
  const cleanedProps = cleanFormProps(rest, componentProps);
  const labelClassNames = clsx({
    [labelClassName]: labelClassName
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "checkbox",
    className: rootClasses,
    children: [/*#__PURE__*/_createElement(ReaxlCheckbox, {
      ...cleanedProps,
      key: label,
      secondaryLabel: secondaryLabel,
      label: label,
      labelClassName: labelClassNames,
      checked: value,
      onChange: createChainedFunction(handleChange, onChange),
      disabled: isFormDisabled || disabled,
      value: value
    }), /*#__PURE__*/_jsx(FormElementHelp, {
      help: formElementProps.help
    }), /*#__PURE__*/_jsx(ErrorMessages, {
      errors: formElementProps.errors,
      showErrors: formElementProps.showErrors
    })]
  });
}
export default /* #__PURE__ */withFormsy(/* #__PURE__ */CommonFormComponent(/*#__PURE__*/memo(Checkbox)));